import { PageTitle } from '#app/components/layout/page-title.tsx'

export default function DatenschutzPage() {
	return (
		<div className="overflow-hidden">
			<PageTitle titleText="Publicare Datenschutz" />
			<div className="[&_a]:text-pcblue-default [&>h1]:text-h5 [&>h1]:md:text-h4 [&>h1]:lg:text-h3 container [&_a]:pl-2 [&_a]:break-words [&>p]:mb-2 [&>p]:text-justify">
				<p>
					Diese Website wird betrieben von der Publicare GmbH (FN 225286d), in
					der Folge „wir“, „uns“ und „Publicare“, mit Sitz in 4061 Pasching, An
					der Trauner Kreuzung 1. In dieser Datenschutzerklärung wird von uns
					als Verantwortlichem nach Art. 4 Abs. 7 DSGVO beschrieben, welche
					Daten wir bei Ihrem Besuch auf unserer Website erheben und zu welchem
					Zweck wir diese verarbeiten. Zudem informieren wir Sie darüber, wie
					wir allgemein Daten unserer Kunden, Lieferanten und Interessenten
					verarbeiten und erläutern abschließend, welche Rechte und Sicherheiten
					wir im Zuge der Datenverarbeitung bieten. Alle relevanten Kontaktdaten
					entnehmen Sie bitte Punkt 11. dieser Datenschutzerklärung. Da uns der
					Schutz Ihrer personenbezogenen Daten ein besonderes Anliegen ist,
					halten wir uns beim Erheben und Verarbeiten Ihrer personenbezogenen
					Daten streng an die gesetzlichen Vorgaben des DSG und der DSGVO.
					<br />
					Da uns der Schutz Ihrer personenbezogenen Daten ein besonderes
					Anliegen ist, halten wir uns beim Erheben und Verarbeiten Ihrer
					personenbezogenen Daten streng an die gesetzlichen Vorgaben des DSG
					und der DSGVO.
					<br />
					Im Folgenden informieren wir Sie detailliert über den Umfang und den
					Zweck unserer Datenverarbeitung sowie Ihre Rechte als Betroffene/r der
					Datenverarbeitung. Lesen Sie unsere Datenschutzerklärung daher bitte
					genau durch, bevor Sie unsere Website weiter nutzen und gegebenenfalls
					Ihre Einwilligung zu einer Datenverarbeitung geben.
				</p>
				<br />
				<h1>1. Personenbezogene Daten</h1>
				<p>
					Die Nutzung unserer Website ist grundsätzlich ohne Angabe von
					personenbezogenen Daten möglich. Für die Nutzung einzelner Services
					können sich jedoch abweichende Regelungen ergeben, auf die wir Sie
					gesondert hinweisen.
					<br />
					Personenbezogene Daten sind alle Informationen, die sich auf eine
					identifizierte oder identifizierbare natürliche Person beziehen.
					Darunter fallen beispielsweise Ihr Name, Ihre Anschrift, Ihre
					Telefonnummer oder Ihr Geburtsdatum, aber auch Ihre IP-Adresse oder
					Geolokationsdaten, die einen Rückschluss auf Sie zulassen.
				</p>
				<br />
				<h1>2. Verwendung von Cookies</h1>
				<p>
					<strong>a. </strong>
					Sofern Sie unsere Website lediglich zu Informationszwecken nutzen,
					also wenn Sie sich nicht für einen Service registrieren oder uns –
					etwa über ein Kontaktformular – anderweitig Informationen übermitteln,
					erfassen wir nur die (personen-)bezogenen Daten, die Ihr Browser an
					unseren Server übermittelt. Sofern Sie also unsere Website besuchen
					möchten, erheben wir die nachfolgend angeführten Daten, die für uns
					technisch erforderlich sind, um Ihnen die Website anzuzeigen und deren
					Stabilität und Sicherheit gem. Art. 6 Abs. 1 S. 1 lit. f DSGVO zu
					gewährleisten:
				</p>
				<ul className="ml-8 list-disc">
					<li>IP-Adresse</li>
					<li>Datum und Uhrzeit der Anfrage</li>
					<li>Zeitzonendifferenz zur Greenwich Mean Time (GMT)</li>
					<li>Inhalt der Anforderung</li>
					<li>Zugriffsstatus / http-Statuscode</li>
					<li>Jeweils übertragene Datenmenge</li>
					<li>Website, von der die Anforderung kommt</li>
					<li>Verwendeter Browser</li>
					<li>Betriebssystem und dessen Oberfläche</li>
					<li>Sprache und Version der Browsersoftware</li>
				</ul>
				<p>
					Über den Zweck des Anzeigens unserer Website hinaus werden diese Daten
					jedoch nicht verarbeitet.
				</p>
				<br />
				<p>
					<strong>b. </strong> Ergänzend zu den zuvor genannten Daten werden bei
					Ihrer Nutzung unserer Website First und Third-Party Cookies auf Ihrem
					Rechner gespeichert; dies sind kleine Textdateien, die auf Ihrer
					Festplatte in dem von Ihnen verwendeten Browser zugeordnet gespeichert
					werden. Die Stelle, die einen Cookie setzt (dies erfolgt entweder
					durch uns oder einen explizit angeführten Dritten), erhält dadurch
					bestimmte Informationen.
					<br />
					Diese Cookies benötigen wir einerseits um Sie als Nutzer der Website
					zu erkennen und andererseits, um die Nutzung unserer Services
					nachvollziehbar machen zu können. Zuletzt setzen wir gegebenenfalls
					Cookies zu Marketingzwecken ein, um Ihr Nutzungsverhalten zu
					analysieren und Ihnen im Anlassfall zielgerichtete Werbung zukommen zu
					lassen.
				</p>
				<br />
				<p>
					<strong>c. </strong> Man kann grundsätzlich zwischen First Party
					Cookies, Third Party Cookies und Third Party Requests unterscheiden.
				</p>
				<ul className="ml-8 list-disc">
					<li>First Party Cookies</li>
				</ul>
				<p>
					First Party Cookies werden von uns bzw. unserer Website selbst in
					Ihrem Browser gespeichert, um Ihnen ein bestmögliches Nutzungserlebnis
					zu bieten. Dabei handelt es sich insbesondere um funktionale Cookies,
					wie etwa Warenkorb-Cookies. Wir setzen gegebenenfalls auch Cookies
					ein, um Sie für Folgebesuche identifizieren zu können, falls Sie über
					einen Account bei uns verfügen – andernfalls müssen Sie sich bei jedem
					Besuch neu einloggen.
				</p>
				<ul className="ml-8 list-disc">
					<li>Third Party Requests</li>
				</ul>
				<p>
					Third Party Request sind alle Anfragen, die Sie als Seitenbenutzer
					über unsere Seite an Dritte stellen – also beispielsweise, wenn Sie
					mit Plugins sozialer Netzwerke agieren oder etwa das Angebot eines
					Bezahlanbieters nutzen. In diesem Fall werden zwar keine Cookies in
					Ihrem Browser gespeichert, es ist aber nicht auszuschließen, dass
					durch die Interaktion personenbezogene Daten an diesen Drittanbieter
					gesendet werden. Aus diesem Grund informieren wir Sie auch im Detail
					in unserer Datenschutzerklärung über die von uns eingesetzten Tools &
					Applikationen.
				</p>
				<br />
				<p>
					<strong>d. </strong> Um Sie umfassend über die von uns verwendeten
					Cookies zu informieren, haben wir in Übereinstimmung mit der Judikatur
					des EuGH vom 01.10.2019, C-673/17 (Planet 49) sowie weiteren
					einschlägigen Entscheidungen einen Cookie-Banner gestaltet, der Ihnen
					bei erstem Aufruf unserer Website angezeigt wird. In diesem
					Cookie-Banner sind sämtliche verwendeten Cookies samt deren Funktion,
					Speicherdauer und Herkunft dargestellt. Nur, wenn Sie der Verwendung
					einiger oder aller Cookies zustimmen, werden diese von uns
					gespeichert; eine Ausnahme davon können technisch zwingend
					erforderliche Cookies bilden, ohne deren Einsatz unsere Website nicht
					korrekt angezeigt werden könnte. Details über die verwendente Cookies
					können sie dem Cookiebanner entnehmen bzw. finden sie auf auch auf der
					<a href="https://publicare.at/cookie-erklaerung/">
						Cookie-Erklärung
					</a>{' '}
					Seite aufgelistet.
				</p>
				<br />
				<p>
					<strong>e.</strong> Es ist Ihnen jederzeit möglich, Ihre
					Browsereinstellungen dahingehend abzuändern, dass Sie beispielsweise
					die Annahme von Third-Party-Cookies oder allen Cookies ablehnen. In
					diesem Fall müssen wir Sie jedoch darauf hinweisen, dass Sie eventuell
					nicht mehr alle Funktionen unserer Website nutzen können.
				</p>
				<br />
				<h1>3. Erhebung und Verarbeitung personenbezogener Daten</h1>
				<div>
					{' '}
					<p className="text-lg md:text-xl">
						<strong> a.</strong> Website
					</p>
				</div>

				<p>
					Personenbezogene Daten, die über die durch Cookies gespeicherten
					Informationen hinausgehen, werden von uns im Rahmen des Betriebs
					unserer Website ausschließlich verarbeitet, wenn Sie uns diese von
					sich aus freiwillig mitteilen, beispielsweise wenn Sie sich bei uns
					registrieren, in eine Vertragsbeziehung mit uns eintreten oder sonst
					mit uns in Kontakt treten. Dabei handelt es sich ausschließlich um
					Kontaktdaten sowie Informationen zu den Anliegen, mit denen Sie an uns
					herantreten.
				</p>
				<p>
					Wir verwenden die von Ihnen angegebenen personenbezogenen Daten
					ausschließlich insoweit, als dies im Rahmen der Erfüllung des
					jeweiligen Zwecks der Verarbeitung (zB die Registrierung, die
					Newsletter-Versendung, die Abwicklung einer Bestellung, das Zusenden
					von Informationsmaterial und Werbung, die Abwicklung eines
					Gewinnspieles, die Beantwortung einer Frage, die Ermöglichung des
					Zugangs zu bestimmten Informationen) erforderlich und dies gesetzlich
					(insb. gem. Art. 6 bzw. Art. 9 DSGVO) zulässig ist (z.B. die
					Aussendung von Werbung und Informationsmaterial an Bestandskunden gem.
					Art. 6 Abs. 1 S. 1 lit. f DSGVO).
				</p>
				<p>
					Zweck der Verarbeitung Ihrer Daten ist das Betreiben unserer Website
					und die zielgerichtete Zurverfügungstellung von
					unternehmensspezifischen Informationen samt der Darstellung des
					Angebots unserer Waren und Dienstleitungen (Marketing).
				</p>
				<p>
					Eine darüberhinausgehende Verwendung Ihrer Daten findet nur insoweit
					statt, als Sie zuvor ausdrücklich eingewilligt haben, wir Ihre Daten
					zur Erfüllung eines mit Ihnen abgeschlossenen Vertrags benötigen oder
					aufgrund einer gesetzlichen Bestimmung verpflichtet sind, diese
					aufzubewahren. Jede erteilte Einwilligung können Sie – wie nachstehend
					noch detailliert erläutert – jederzeit für die Zukunft widerrufen.
				</p>
				<div>
					<p className="text-lg md:text-xl">
						<strong> b.</strong> Vertragsabwicklung, Marketing und mehr
					</p>
				</div>

				<p>
					Allgemein nutzen wir personenbezogene Daten unserer Kunden,
					Lieferanten und sonstiger Vertrags- und Kooperationspartner, z.B.
					Ansprechpersonen, deren Kontaktdaten und marketingrelevante
					Informationen, zum Zweck der Vertragsabwicklung und im Rahmen
					gesetzlicher Aufbewahrungspflichten (zb.: Rechnungswesen), und darüber
					hinaus auch aus berechtigtem Interesse, etwa zu Marketing- und
					Kundenbetreuungszwecken.
				</p>
				<p>
					Zudem erfassen wir personenbezogene Daten von Interessenten (z.B.
					Ansprechpersonen, deren Kontaktdaten und marketingrelevante
					Informationen) im Zuge unserer Akquise- und Vertriebstätigkeiten. Wir
					sind stets im Internet, auf Messen und bei sonstigen Veranstaltungen
					auf der Suche nach potentiellen Vertragspartnern und führen zu diesem
					Zweck eine Marketingdatenbank, um eine zielgerichtete Werbung für
					unsere Produkte und Dienstleistungen zu ermöglichen. Sämtliche der
					hier angeführten Maßnahmen führen wir im berechtigten Interesse zu
					Marketingzwecken gem. Art. 6 Abs. 1 S. 1 lit. f DSGVO iVm.
					Erwägungsgrund 47 für die Dauer von drei Jahren ab dem Ende eines
					Vertragsverhältnisses (Kunden & Lieferanten) bzw. unserer erstmaligen
					(fruchtlos gebliebenen) Kontaktaufnahme (Interessenten) durch, sofern
					nicht eine darüberhinausgehende ausdrückliche Einwilligung des
					Betroffenen vorliegt.
				</p>
				<p>
					Wenn wir personenbezogene Daten zu Marketingzwecken nicht bei der
					betroffenen Person selbst erheben, teilen wir dem Betroffenen gem.
					Art. 14 DSGVO bei erstmaliger Kontaktaufnahme zudem mit, wo wir seine
					Daten erhoben haben.
				</p>
				<div>
					<p className="text-lg md:text-xl">
						<strong> c.</strong> Bewerbungsmanagement
					</p>
				</div>

				<p>
					Daten von Bewerbern für bei uns offenen Jobangeboten erfassen wir zum
					Zweck der Anbahnung eines möglichen Beschäftigungsverhältnisses Art. 6
					Abs. 1 S. 1 lit. b DSGVO bzw. allenfalls aufgrund einer expliziten
					Einwilligung zu Evidenzzwecken.
				</p>
				<div>
					<p className="text-lg md:text-xl">
						<strong> d.</strong> Upload-Formular für Verordnungsscheine
					</p>
				</div>

				<p>
					Wir stellen unseren Kooperationspartnern, Kunden und sonstigen mit
					Medizinprodukten befassten Personen ein Online-Upload-Formular für
					Verordnungsscheine zur Verfügung, um einen sicheren Transfer von
					Verordnungsscheinen für Patientinnen und Patienten zu gewährleisten.
				</p>
				<p>
					Da in den Verordnungsscheinen besondere Kategorien personenbezogener
					Daten gem. Art. 9 DSGVO (Gesundheitsdaten) verarbeitet werden, ist die
					Nutzung des Upload-Formulars nur mit ausdrücklicher mündlicher oder
					schriftlicher Zustimmung des Patienten oder der Patientin zulässig.
					Sofern der Patient oder die Patientin das Upload-Formular selbst
					nutzt, erklärt er durch die Nutzung die Einwilligung in die
					Datenverarbeitung durch die Verantwortliche.
				</p>
				<p>
					Die Verarbeitung der personenbezogenen Daten erfolgt für die Dauer des
					Vertragsverhältnisses zwischen uns und unseren Kunden sowie darüber
					hinaus für die Dauer gesetzlicher Aufbewahrungspflichten (z.B. §132
					BAO). Für den Fall des Widerrufs der zur Verarbeitung der besonderen
					Kategorien personenbezogener Daten erteilten Einwilligung werden die
					personenbezogenen Daten anonymisiert oder gelöscht, sofern nicht eine
					gesetzliche Pflicht zur weitergehenden Aufbewahrung besteht.
				</p>
				<p>
					Im Zusammenhang mit unserem Upload-Formular setzen wir verschiedene
					Auftragsverarbeiter ein, u.A. die MangoART GmbH, Microsoft Inc. und
					Functional Software, Inc. ein. Wir stellen durch entsprechende
					Vertragswerke sicher, dass durch unsere Auftragsverarbeiter
					personenbezogene Daten rechtssicher und datenschutzkonform verarbeitet
					werden.
				</p>
				<br />
				<h1>4. Speicherdauer</h1>
				<p>
					Daten, die Sie uns ausschließlich zur Kundenbetreuung bzw. für
					Marketing und Informationszwecke zur Verfügung gestellt haben,
					speichern wir grundsätzlich bis zum Ablauf von drei Jahren nach
					unserem letzten Kontakt. Sofern Sie dies wünschen, werden wir Ihre
					Daten jedoch auch vor Ablauf dieser Frist löschen, sofern kein
					gesetzliches Hindernis dem entgegensteht.
				</p>
				<p>
					Im Falle einer/s Vertragsanbahnung bzw. -abschlusses verarbeiten wir
					Ihre personenbezogenen Daten nach vollständiger Vertragsabwicklung bis
					zum Ablauf der für uns geltenden Garantie-, Gewährleistungs-,
					Verjährungs- und gesetzlichen Aufbewahrungsfristen, darüber hinaus bis
					zur Beendigung von allfälligen Rechtsstreitigkeiten, bei denen die
					Daten als Beweis benötigt werden.
				</p>
				<p>
					Daten, die Sie uns gegebenenfalls im Rahmen eines Bewerbungsprozesses
					übermitteln, werden wir ohne gesonderte Zustimmung lediglich für die
					Dauer von 6 Monaten aufbewahren.
				</p>

				<p>
					Wenn eine Aufbewahrung gesetzlich erforderlich ist, entsprechen wir
					der dort normierten Frist. Sofern wir Ihre personenbezogenen Daten –
					etwa aus berechtigtem Interesse – über die in dieser
					Datenschutzerklärung dargestellten Zwecke verarbeiten, werden wir Sie
					vor der Aufnahme der Verarbeitung gesondert darüber informieren.
				</p>
				<br />
				<h1>5. Datenübermittlung</h1>
				<div>
					<p className="text-lg md:text-xl">
						<strong> a.</strong> Upload-Formular für Verordnungsscheine
					</p>
				</div>

				<p>
					Eine Übermittlung Ihrer Daten an Dritte findet grundsätzlich nicht
					statt, es sei denn, wir sind gesetzlich dazu verpflichtet, die
					Datenweitergabe ist zur Durchführung eines zwischen uns
					abgeschlossenen Vertragsverhältnisses erforderlich oder Sie haben
					zuvor ausdrücklich in die Weitergabe Ihrer Daten eingewilligt.
				</p>
				<p>
					Externe Auftragsverarbeiter oder sonstige Kooperationspartner erhalten
					Ihre Daten nur, soweit dies zur Vertragsabwicklung erforderlich ist,
					wir ein berechtigtes Interesse daran haben, das wir stets im
					Anlassfall gesondert bekannt geben oder sofern dies aufgrund von
					Sondernormen erforderlich ist, mit Ihrer Zustimmung.
				</p>
				<p>
					Ihre personenbezogenen Daten werden von uns nicht an Dritte veräußert
					oder anderweitig vermarktet. Sofern unsere Vertragspartner oder
					Auftragsverarbeiter ihren Sitz in einem Drittland, also einem Staat
					außerhalb des Europäischen Wirtschaftsraums (EWR) haben, informieren
					wir Sie über die Folgen dieses Umstands in der Beschreibung des
					Angebots.
				</p>
				<p>
					Soweit einer unserer Auftragsverarbeiter mit Ihren personenbezogenen
					Daten in Berührung kommt, stellen wir sicher, dass diese die
					Vorschriften der Datenschutzgesetze in gleicher Weise einhält wie wir.
				</p>
				<div>
					<p className="text-lg md:text-xl">
						<strong> b.</strong> Datenübermittlung in die USA?
					</p>
				</div>

				<p>
					Wir bieten gelegentlich einige Dienste an, in deren Zuge eine
					Datenübermittlung in die USA stattfindet bzw. stattfinden kann. Die
					Übermittlung von Daten in die USA hat in den letzten Jahren stets zu
					rechtlichen Herausforderungen geführt. Es gibt mehrere
					Rechtsgrundlagen für eine rechtskonforme Datenübertragung in die USA,
					wobei wir uns grundsätzlich auf zwei verschiedene Rechtsgrundlagen
					stützen:
				</p>
				<ul className="ml-8 list-disc">
					<li>
						Datenübermittlung aufgrund Vorliegens eines
						Angemessenheitsbeschlusses
					</li>
				</ul>
				<p>
					Am 10. Juli 2023 wurde von der Europäischen Kommission ein neuer
					Angemessenheitsbeschluss gemäß Art. 45 DSGVO für die USA – nämlich das
					EU-U.S. Data Privacy Network – angenommen.
				</p>
				<p>
					Dieser Angemessenheitsbeschluss gilt jedoch nur für jene
					Datenimporteure in den USA, die in der Data Privacy Framework List
					registriert sind
					<a href="https://www.dataprivacyframework.gov/s/participant-search">
						(https://www.dataprivacyframework.gov/s/participant-search)
					</a>
					.
				</p>
				<p>
					Wir prüfen für jeden unseren Dienstleister, der als Datenimporteuer
					personenbezogene Daten in den USA erhalten soll, ob dieser in der Data
					Privacy Framework List registriert ist. Sofern dies der Fall ist, ist
					dies in unserer Datenschutzerklärung jeweils beim jeweiligen
					Dienstleister angeführt.
				</p>
				<p>
					Die Pressemitteilung der EU-Kommission zum EU-U.S. Data Privacy
					Network finden Sie unter:
					<a href="https://ec.europa.eu/commission/presscorner/detail/en/ip_23_3721">
						https://ec.europa.eu/commission/presscorner/detail/en/ip_23_3721.
					</a>
				</p>
				<ul className="ml-8 list-disc">
					<li>Einwilligung</li>
				</ul>
				<p>
					Sofern ein Datenimporteuer nicht in der Data Privacy Framework List
					registriert ist, ist es – sofern kein anderer Rechtfertigungsgrund wie
					etwa die Erfüllung von vertraglichen Verpflichtungen besteht – jedoch
					erforderlich, dass Sie Sie der Verwendung Ihrer über diese Dienste
					erfassten Daten gegebenenfalls auch in den USA zustimmen (Art 49 Abs.
					1 lit. a DSGVO).
				</p>
				<p>
					Dies, da wir derzeit noch nicht beurteilen können, wie sich die
					Rechtsprechung infolge des EU-U.S. Data Privacy Network entwickelt.
					Diese Zustimmung erfassen wir – je nach Dienst – über unseren
					Cookie-Banner oder separat durch entsprechende Zustim-mungserklärung
					direkt vor der Nutzung eines angebotenen Dienstes.
				</p>
				<p>
					Ihre Zustimmung ist erforderlich, da gemäß zuletzt ergangener
					Behörden- und Gerichtsentscheidungen und der Rechtsprechung des EuGH
					den USA kein angemessenes Datenschutzniveau bei der Verarbeitung von
					personenbezogenen Daten bescheinigt wird (C-311/18, Schrems II). In
					diesen Behörden- und Gerichtsentscheidungen wird insbesondere kritisch
					aufgezeigt, dass Zugriffe durch US-Behörden (FISA 0702) gesetzlich
					nicht umfassend eingeschränkt sind, keiner Genehmigung durch eine
					unabhängige Instanz bedürfen und keine relevanten Rechtsbehelfe bei
					entsprechenden Eingriffen für die Betroffenen zur Verfügung stehen.
				</p>
				<p>
					Wir haben – abgesehen von den mit US-Dienstleistern abgeschlossenen
					Verträgen – keinen unmittelbaren Einfluss auf den Zugriff von
					US-Behörden auf personenbezogene Daten, die bei Verwendung dieser
					Dienste an Dienstleister in die USA übertragen werden. Auch wenn wir
					davon ausgehen, dass unsere Dienstleister entsprechend den mit uns
					vertraglich getroffenen Vereinbarungen die erforderlichen Schritte
					setzen, das versprochene Schutzniveau zu gewährleisten, ist ein
					Zugriff durch US-Behörden auf in den USA verarbeitete Daten trotzdem
					denkbar.
				</p>
				<p>
					Wir ersuchen Sie daher vor Verwendung derartiger Dienste um Ihre
					Zustimmung zur Verarbeitung der Daten in den USA. Wir werden bei jedem
					Dienst bzw. jeder Applikation gesondert darauf hinweisen, dass die
					Möglichkeit einer Datenübertragung in die USA besteht.
				</p>
				<br />
				<h1>6. Newsletter</h1>
				<p>
					Sie haben die Möglichkeit, unseren kostenlosen Newsletter zu
					abonnieren. Mit diesem Newsletter erhalten Sie in regelmäßigen
					Abständen alle aktuellen Neuigkeiten und Informationen über unser
					Unternehmen sowie maßgeschneiderte Werbung. Um unseren Newsletter
					empfangen zu können, benötigen sie eine gültige E-Mail-Adresse.
				</p>
				<p>
					Die von Ihnen in unserer Anmeldemaske eingetragene E-Mail-Adresse
					überprüfen wir dahingehend, ob der Empfang von Newslettern tatsächlich
					gewünscht ist. Dies erfolgt dadurch, dass wir Ihnen an die von Ihnen
					genannte E-Mail-Adresse eine E-Mail schicken, deren Erhalt Sie durch
					Klick auf einen zur Verfügung gestellten Link bestätigen können. Nach
					Bestätigung der E-Mail sind Sie für unseren Newsletter angemeldet.
					(Double Opt-In)
				</p>
				<p>
					Bereits mit erster Anmeldung zum Newsletter speichern wir Ihre
					IP-Adresse, das Datum und die Uhrzeit Ihrer Anmeldung. Dies geschieht
					aus Sicherheitsgründen für den Fall, dass ein Dritter Ihre
					E-Mail-Adresse missbraucht und ohne Ihr Wissen unseren Newsletter
					abonniert. Weitere Daten werden von uns für das Newsletter-Abonnement
					nicht erhoben und verarbeitet, die Daten werden ausschließlich für den
					Bezug des Newsletters verwendet.
				</p>
				<p>
					Sofern Sie dem nicht widersprechen, übermitteln wir Ihre Daten
					gegebenenfalls an mit unserem Unternehmen gesellschaftsrechtlich
					verbundene Unternehmen zum Zwecke der Analyse sowie zur Übermittlung
					von Informationen zu Werbezwecken. Innerhalb der Unternehmensgruppe
					werden Ihre Daten, die Sie uns zum Bezug des Newsletters zur Verfügung
					gestellt haben mit Daten, die möglicherweise durch uns anderweitig (zB
					beim Kauf von einer Ware oder Buchung einer Dienstleistung) erhoben
					werden, abgeglichen.
				</p>
				<p>
					Eine Weitergabe Ihrer Daten zur Newsletter-Anmeldung an Dritte, die
					nicht zur Unternehmensgruppe gehören, erfolgt nicht. Den Bezug unserer
					Newsletters können Sie jederzeit beenden, die Details zur Abmeldung
					finden Sie im Bestätigungsmail und in jedem einzelnen Newsletter.
				</p>
				<br />
				<h1>7. Verwendete Tools und Applikationen</h1>
				<p>
					<strong>a.</strong> Wir verwenden Google Analytics, dabei handelt es
					sich um einen Webanalysedienst der Google LLC, 1600 Amphitheatre
					Parkway, Mountain View, CA 94043, USA. Dieser Dienst verwendet
					Cookies, deren Funktionalität bereits zuvor ausführlich dargelegt
					wurde. Die durch diese Cookies erzeugten Informationen über Ihre
					Benutzung dieser Website werden in der Regel an einen Server von
					Google übertragen und dort gespeichert.
				</p>
				<p>
					In unserem Auftrag benutzt Google diese Informationen, um Ihre Nutzung
					unserer Website auszuwerten, um Reports über die Websiteaktivitäten
					zusammenzustellen und um weitere mit der Websitenutzung und der
					Internetnutzung verbundene Dienstleistungen gegenüber dem
					Websitebetreiber zu erbringen. Die im Rahmen von Google Analytics von
					Ihrem Browser übermittelte IP-Adresse wird nicht mit anderen Daten von
					Google zusammengeführt.
				</p>
				<p>
					Sie können die Speicherung der von Google Analytics benötigten Cookies
					durch eine entsprechende Einstellung Ihrer Browser-Software
					verhindern, was allerdings dazu führen kann, dass Sie gegebenenfalls
					nicht sämtliche Funktionen dieser Website vollumfänglich nutzen
					können. Die Erfassung der durch das Cookie erzeugten und auf Ihre
					Nutzung der Website bezogenen Daten (inkl. Ihrer IP-Adresse) sowie
					deren Übermittlung und Verarbeitung durch Google können Sie auch
					verhindern, indem sie das unter dem folgenden Link verfügbare
					Browser-Plugin herunterladen und installieren:
					<a href="http://tools.google.com/dlpage/gaoptout?hl=de">
						http://tools.google.com/dlpage/gaoptout?hl=de
					</a>
				</p>
				<p>
					Sollten Sie weiterführende Informationen zu Art, Umfang und Zweck der
					von Google erhobenen Daten informieren wollen, empfehlen wir Ihnen,
					deren Datenschutzbestimmungen zu lesen.
					<a href="https://support.google.com/analytics/answer/6004245?hl=de">
						https://support.google.com/analytics/answer/6004245?hl=de
					</a>
				</p>
				<p>
					Google verarbeitet Ihre Daten auch in den USA. Bevor Sie Ihre
					Zustimmung zu der Speicherung von Cookies durch die Verwendung von
					Google Analytics erteilen, lesen Sie bitte die diesbezüglichen
					Informationen in unserer Datenschutzerklärung.
				</p>
				<p>Google LLC ist in der Data Privacy Framework List registriert.</p>
				<p>
					<strong>b.</strong> Auf unserer Website setzen wir Mouseflow ApS ein.
					Mouseflow ist eine Plattform für Verhaltensanalysen, die es uns
					ermöglicht, die Benutzererfahrung und die Konversionsraten auf unserer
					Website zu verstehen und zu verbessern. Mit Sitzungsaufzeichnungen,
					Heatmaps und der Erfassung von Benutzerfeedback ermöglicht die
					Software, Erkenntnisse über das Verhalten von Nutzern zu gewinnen, das
					„Warum“ hinter den Zahlen herauszufinden und eine bessere
					Benutzererfahrung zu schaffen.
				</p>
				<p>
					<strong>c.</strong> Ein weiteres Tool, dass wir auf unserer Webseite
					integriert haben, ist Cloudflare Turnstile. Cloudflare Turnstile
					bestätigt, dass es sich bei unseren Webbesuchern um echte Personen
					handelt und blockiert unerwünschte Bots, ohne die Weberfahrung für
					echte Nutzer zu beeinträchtigen. Unser Vertragspartner ist dabei die
					Cloudflare Germany GmbH, Rosental 7, c/o Mindspace, 80331 München.
				</p>
				<br />
				<h1>8. Gemeinsame Verantwortlichkeiten gem. Art. 26 DSGVO</h1>
				<div>
					{' '}
					<p className="text-lg md:text-xl">
						<strong> a.</strong> Facebook – Fansite
					</p>
				</div>

				<p>
					Wir betreiben eine Facebook – Fanseite unter
					<a href="https://www.facebook.com/Publicare.at">
						https://www.facebook.com/Publicare.at
					</a>
					. Diese Fanseite verfolgt den Zweck, Informationen zu den Tätigkeiten
					unseres Unternehmens zu teilen, Marketingmaßnahmen zu setzen und einen
					weiteren Kommunikationskanal mit uns zu bieten.
				</p>
				<p>
					In diesem Zusammenhang sind wir „gemeinsame Verantwortliche“ mit
					Facebook, betrieben von der Meta Platforms Ireland Limited, 4 Grand
					Canal Square, Grand Canal Harbour, Dublin 2, Irland, die uns diesen
					Service zur Verfügung stellt. Grundsätzlich ermöglicht Ihnen Facebook,
					in Ihren Einstellungen auszuwählen, welche personenbezogenen Daten mit
					uns geteilt werden. Sofern Sie dies nicht möchten, erhalten wir alle
					Informationen betreffend die Nutzung unserer Fanseite und
					personenbezogene Daten zu den Besuchern in anonymisierter Form.
				</p>
				<p>
					Wir haben zu diesem Zweck mit Facebook eine sog. Art. 26
					DSGVO-Vereinbarung abgeschlossen, in der die wechselseitigen Rechte
					und Pflichten von uns und von Facebook geregelt werden. Diese finden
					Sie unter
					<a href="https://www.facebook.com/legal/EU_data_transfer_addendum/update">
						https://www.facebook.com/legal/EU_data_transfer_addendum/update
					</a>
					. In diesem Zusammenhang ersuchen wir Sie auch, die
					Datenschutzbestimmungen von Facebook zu lesen, die Sie unter
					<a href="https://www.facebook.com/policy.php">
						https://www.facebook.com/policy.php
					</a>{' '}
					finden.
				</p>
				<p>
					In der von uns abgeschlossenen Art. 26 –DSGVO-Vereinbarung
					verpflichtet sich Facebook, erste Anlaufstelle für die Betroffenen
					betreffend die Verarbeitung von Insights-Daten zu sein und die damit
					in Verbindung stehenden Pflichten und Aufgaben zu erfüllen.
				</p>
				<p>
					Ihre Betroffenenrechte können Sie daher sowohl gegenüber uns gemäß
					Punkt 10. dieser Datenschutzerklärung, als auch gegenüber der Meta
					Platforms Ireland Limited, 4 Grand Canal Square, Grand Canal Harbour,
					Dublin 2, Irland, geltend machen.
				</p>
				<div>
					<p className="text-lg md:text-xl">
						<strong> b.</strong>Instagram – Profil
					</p>
				</div>

				<p>
					Wir betreiben ein Instagram – Profil unter „publicare.at“. Mit diesem
					Profil wollen wir Marketingmaßnahmen setzen, auf unsere Produkte und
					Dienstleistungen aufmerksam machen und einen weiteren
					Kommunikationskanal mit unseren Kunden schaffen.
				</p>
				<p>
					Auch in diesem Zusammenhang sind wir „gemeinsame Verantwortliche“ mit
					Instagram, betrieben von der Meta Platforms Ireland Limited, 4 Grand
					Canal Square, Grand Canal Harbour, Dublin 2, Irland, die uns diesen
					Service zur Verfügung stellt. Grundsätzlich ermöglicht Ihnen
					Instagram, in Ihren Einstellungen auszuwählen, welche
					personenbezogenen Daten mit uns geteilt werden. Sofern Sie dies nicht
					möchten, erhalten wir alle Informationen betreffend die Nutzung
					unserer Fanseite und personenbezogene Daten zu den Besuchern in
					anonymisierter Form.
				</p>
				<p>
					Wir haben zu diesem Zweck mit Instagram eine sog. Art. 26
					DSGVO-Vereinbarung abgeschlossen, in der die wechselseitigen Rechte
					und Pflichten von uns und von Ins-tagram geregelt werden. Diese finden
					Sie unter
					<a href="https://www.facebook.com/legal/EU_data_transfer_addendum/update">
						https://www.facebook.com/legal/EU_data_transfer_addendum/update
					</a>
					. In diesem Zusammenhang ersuchen wir Sie auch, die
					Datenschutzbestimmungen von Instagram zu lesen, die Sie unter
					<a href="https://help.instagram.com/519522125107875">
						https://help.instagram.com/519522125107875
					</a>
					finden.
				</p>
				<p>
					In der von uns abgeschlossenen Art. 26 DSGVO-Vereinbarung verpflichtet
					sich Instagram, erste Anlaufstelle für die Betroffenen betreffend die
					Verarbeitung von Insights-Daten zu sein und die damit in Verbindung
					stehenden Pflichten und Aufgaben zu erfüllen.
				</p>
				<p>
					Ihre Betroffenenrechte können Sie daher sowohl gegenüber uns gemäß
					Punkt 10. die-ser Datenschutzerklärung, als auch gegenüber der Meta
					Platforms Ireland Limited, 4 Grand Canal Square, Grand Canal Harbour,
					Dublin 2, Irland, geltend machen.
				</p>
				<br />
				<h1>9. Sicherheit</h1>
				<p>
					Wir setzen zahlreiche technische und organisatorische
					Sicherheitsmaßnahmen ein, um Ihre Daten gegen Manipulationen, Verlust,
					Zerstörung und gegen den Zugriff Dritter zu schützen. Unsere
					Sicherheitsmaßnahmen werden entsprechend der technologischen
					Entwicklung im Internet laufend verbessert. Sollten Sie nähere
					Informationen zu Art und Umfang der von uns ergriffenen technischen
					und organisatorischen Maßnahmen haben, stehen wir für diesbezügliche
					schriftliche Anfragen jederzeit gerne zur Verfügung.
				</p>
				<br />
				<h1>10. Ihre Rechte</h1>
				<p>
					Gemäß der Datenschutz-Grundverordnung und dem Datenschutzgesetz stehen
					Ihnen als betroffener Person unserer Datenverarbeitung folgende Rechte
					und Rechtsbehelfe zu:
				</p>
				<ul className="ml-8 list-disc">
					<li>
						Recht auf Auskunft (Art. 15 EU-DSGVO)
						<br /> Sie haben als betroffene Person der oben beschriebenen und
						sonstigen Datenverarbeitung das Recht, Auskunft darüber zu
						verlangen, ob und wenn ja, welche personenbezogenen Daten über sie
						verarbeitet werden. Zu Ihrem eigenen Schutz – damit niemand
						Unberechtigter Auskunft über Ihre Daten erhält – werden wir vor
						Auskunftserteilung ihre Identität in geeigneter Form nachprüfen.
					</li>
					<li>
						Recht auf Auskunft (Art. 15 EU-DSGVO) <br />
						Sie haben das Recht, unverzüglich die Berichtigung Sie betreffender
						unrichtiger personenbezogener Daten bzw. – unter Berücksichtigung
						der Zwecke der Datenverarbeitung – die Vervollständigung
						unvollständiger personenbezogener Daten sowie die Löschung Ihrer
						Daten zu verlangen, sofern die Kriterien des Art. 17 EU-DSGVO
						erfüllt sind.
					</li>
					<li>
						Recht auf Einschränkung der Verarbeitung (Art. 18 EU-DSGVO)
						<br />
						Sie haben unter den gesetzlichen Voraussetzungen das Recht auf
						Einschränkung der Verarbeitung sämtlicher erhobener
						personenbezogener Daten. Diese Daten werden ab dem
						Einschränkungsantrag nur mehr mit Ihrer individuellen Einwilligung
						bzw. zur Geltendmachung und Durchsetzung von Rechtsansprüchen
						verarbeitet.
					</li>
					<li>
						Recht auf Datenübertragbarkeit (Art. 20 EU-DSGVO)
						<br />
						Sie können die ungehinderte und uneingeschränkte Übermittlung von
						personenbezogenen Daten, die Sie uns bereitgestellt haben, an Sie
						oder einen Dritten verlangen.
					</li>
					<li>
						Widerspruchsrecht (Art. 21 EU-DSGVO)
						<br />
						Sie können aus Gründen, die sich aus ihrer besonderen Situation
						ergeben, jederzeit Widerspruch gegen die Verarbeitung der Sie
						betreffenden personenbezogenen Daten, die zur Wahrung unserer
						berechtigten Interessen oder der eines Dritten erforderlich sind,
						einlegen. Ihre Daten werden nach Widerspruch nicht mehr verarbeitet,
						es sei denn, es liegen zwingende schutzwürdige Gründe für die
						Verarbeitung vor, die Ihre Interessen, Rechte und Freiheiten
						überwiegen oder die Verarbeitung dient der Geltendmachung, Ausübung
						oder Verteidigung von Rechtsansprüchen. Gegen die Datenverarbeitung
						zum Zweck der Direktwerbung können Sie jederzeit Widerspruch mit
						Wirkung für die Zukunft erheben.
					</li>
					<li>
						Widerruf einer Einwilligung <br />
						Falls Sie separat eine Einwilligung zur Verarbeitung Ihrer Daten
						erteilt haben, können Sie diese jederzeit widerrufen. Ein solcher
						Widerruf beeinflusst die Zulässigkeit der Verarbeitung Ihrer
						personenbezogenen Daten, nachdem Sie ihn uns gegenüber ausgesprochen
						haben.
					</li>
				</ul>
				<p>
					Ergreifen Sie eine Maßnahme zur Durchsetzung Ihrer oben aufgeführten
					Rechte aus der DSGVO, so hat Publicare unverzüglich, spätestens aber
					innerhalb eines Monats nach Eingang Ihres Antrags, zur beantragten
					Maßnahme Stellung zu nehmen bzw. dem Antrag zu entsprechen.
				</p>
				<br />
				<p>
					<strong>
						Wir werden auf alle angemessenen Anfragen im gesetzlichen Rahmen
						unentgeltlich und möglichst umgehend reagieren.
					</strong>
				</p>

				<p>
					Für Anträge betreffend Verletzung des Rechtes auf Auskunft, Verletzung
					der Rechte auf Geheimhaltung, auf Richtigstellung oder auf Löschung
					ist die Datenschutzbehörde zuständig. Deren Kontaktdaten lauten:
				</p>
				<div>
					Österreichische Datenschutzbehörde <br />
					Barichgasse 40-42 <br />
					1030 Wien <br />
					dsb@dsb.gv.at <br />
				</div>
				<br />
				<h1>11. Kontaktinformationen / Ansprechperson</h1>
				<div>
					<p className="underline">
						<strong>a.</strong> Kontaktinformationen des Verantwortlichen
					</p>
				</div>

				<p>publicare gmbh, an der trauner Kreuzung 1, 4061 Pasching</p>
				<p>
					Telefon <a href="tel:+4372297056016">07229/70560 16</a> <br />
					Telefax <a href="tel:+4372297056060">07229/70560 60</a>
				</p>
				<div>
					<p className="underline">
						<strong>a.</strong> Kontaktinformationen des Datenschutzbeauftragten
					</p>
				</div>

				<p>
					<strong>Herr Mag. Toni Brnada</strong>
				</p>

				<p>
					Dr. Herbert Sperl Ring 3 <br />
					4060 Leonding
				</p>

				<p>
					Email: <a href="mailto:office@spwr.at">office@spwr.at</a>
				</p>
				<p>Stand: Juli 2025</p>
			</div>
		</div>
	)
}
